import { setHistoryTool } from "@/api";

/**
 * 记录用户最近使用的功能
 * 触发时机是打开图片
 */
export const putHistoryToolUse = () => {
  const testToolId = ''; //测试环境工具ID, 文档未补充
  const prodToolId = '4d631cc546794dcdaf09fb32102b14ad'; //正式环境工具ID
  const isProd = process.env.REACT_APP_ENVIRONMENT === 'production';
  const toolId = isProd ? prodToolId : testToolId;
  if (!toolId) {
    console.warn(`tool id not found`);
    return;
  }
  setHistoryTool(toolId);
};
